import ChevronDownIcon from "assets/icons/chevron-down.svg";

import styles from "./PricingFAQ.module.css";

const faqs = [
  {
    q: "Why is Raycast free for personal use?",

    a: "We think of Raycast as a productivity layer that everybody should use to get work done faster. To make it accessible, we don't charge for the individual plan. The plan covers all built-in extensions, such as Clipboard History, Calendar or Window Management and provides access to all public extensions built by our community.",
  },

  {
    q: "Is the free Teams plan a trial?",

    a: "No, the free plan for Teams doesn’t expire, and isn’t a trial. You can use this plan for as long as you want within your organization, however you are limited to just 30 shared Snippets, 30 shared Quicklinks, and 5 Commands across all of your Extensions.",
  },

  {
    q: "How many seats do I get in a Team plan?",

    a: "There is no minimum or maximum amount of seats that your team can have. You add users to your plan when you need to add to your team, and pay per user, per month.",
  },

  {
    q: "Can I have personal Extensions and Team Extensions?",

    a: `Yes, you can create personal Extensions that are personalized to you, and speed up your productivity, and have team Extensions that can be shared around in your organization for everyone to use.

Team Extensions will be available in the Store command, behind a filter for your Team. This is where all of your Team Extensions will live, and where you can install them.`,
  },

  {
    q: "Can I be part of multiple organizations?",

    a: "Yes, there is no limit to how many organizations you can be part of. It’s important to remember to avoid using multiple email addresses for different organizations, as you need to log in to the app in order to access the shared Snippets, Quicklinks and Extensions.",
  },
];

const PricingFAQ = () => (
  <div className={styles.wrapper}>
    <h3>FAQs</h3>
    <p className={styles.subtitle}>Answers to the most frequently asked questions.</p>

    <div>
      {faqs.map((faq, index) => (
        <label className={styles.faq} key={index}>
          <h4 className={styles.question}>{faq.q}</h4>
          <input type="checkbox" />
          <p className={styles.answer}>{faq.a}</p>
          <div className={styles.arrowContainer}>
            <ChevronDownIcon className="icon" />
          </div>
        </label>
      ))}
    </div>
  </div>
);

export default PricingFAQ;
